import { render, staticRenderFns } from "./diagram-view-location-form.component.vue?vue&type=template&id=2ababe68"
import script from "./diagram-view-location-form.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-location-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-location-form.component.vue?vue&type=style&index=0&id=2ababe68&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ababe68')) {
      api.createRecord('2ababe68', component.options)
    } else {
      api.reload('2ababe68', component.options)
    }
    module.hot.accept("./diagram-view-location-form.component.vue?vue&type=template&id=2ababe68", function () {
      api.rerender('2ababe68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/diagram-view-location-form/diagram-view-location-form.component.vue"
export default component.exports